import { TranslationMessages } from 'react-admin'
import enMesssages from 'ra-language-english'

export const en: TranslationMessages = {
  ...enMesssages,
  resources: {
    partners: {
      name: '事業者',
      fields: {
        address: '都道府県以降の住所',
        criterions: '判定基準',
        name: 'お客さま名',
        prefecture: '都道府県',
        start: '契約日',
        phone: '携帯電話番号',
        web: 'ホームページURL',
        postalCode: '郵便番号',
        products: '提供サービス',
        'products.contactDepartment': '担当者部署',
        'products.contactEmail': '担当者メールアドレス',
        'products.contactName': '担当者氏名',
        'products.contactPhone': '担当者電話番号',
        'products.name': 'サービス名称',
        'products.price': '提供価格',
        'products.analytics': '分析',
        'products.criterions': '判定基準',
        'products.criterions.enabled': '有効',
        'products.criterions.startDate': '判定開始日',
        'products.criterions.endDate': '判定終了日',
        'products.criterions.start': '判定開始時刻',
        'products.criterions.end': '判定終了時刻',
        'products.criterions.continuousLimit': '判定継続日数',
        count: '利用ハウス数',
        code: '紹介コード'
      },
      title: '事業者を登録'
    },
    users: {
      name: '利用者',
      fields: {
        customerNumber: 'お客様番号',
        email: 'メールアドレス',
        usersInput: '登録ファイル',
        name: 'ハウス名称',
        partner: '事業者',
        product: 'サービス',
        spin: '供給地点特定番号',
        sms: 'SMS送信先電話番号',
        phone: '電話番号',
        postalCode: '郵便番号',
        families: '緊急連絡先',
        'families.name': '緊急連絡先氏名',
        'families.sms': '緊急連絡先SMS送信先電話番号',
        'families.phone': '緊急連絡先音声連絡先電話番号',
        criterionsAll: '判定基準は他のハウスと共通',
        criterions: '判定基準',
        'criterions.enabled': '有効',
        'criterions.startDate': '判定開始日',
        'criterions.endDate': '判定終了日',
        'criterions.start': '判定開始時刻',
        'criterions.end': '判定終了時刻',
        'criterions.continuousLimit': '判定継続日数',
        month: '月',
        date: '最新の活動状況判定日時',
        continuous: '判定連続日数',
        start: '利用開始日',
        deleted: '解約済み',
        activity: '活動状況',
        time: '時刻',
        amount: '電気使用量(kWh)',
        houseName: 'ハウス名称',
        delete: '削除'
      },
      title: '利用者を登録',
      noName: '未設定'
    },
    partnerNotifications: {
      name: '通知',
      fields: {
        user: '利用者',
        spin: '供給地点特定番号',
        dateTime: '日時',
        kind: '種別',
        smsStatus: 'SMS通知状況',
        emailStatus: '事業者へのメール連絡状況',
        callStatus: '電話連絡状況',
        familyCallStatus: '緊急連絡先への電話連絡状況',
        call: {
          status: '状況',
          report: '詳細',
          person: '報告者',
          date: '報告日時'
        },
        familyCall: {
          status: '状況',
          report: '詳細',
          person: '報告者',
          date: '報告日時'
        },
        confirmed: '安否確認完了',
        confirmedTime: '安否確認完了日時',
        activity: '活動状況',
        time: '時刻',
        amount: '電気使用量(kWh)'
      }
    },
    partnerReports: {
      name: '検知状況',
      fields: {
        user: '利用者',
        spin: '供給地点特定番号',
        dateTime: '日時',
        kind: '種別',
        duration: '継続時間(分)',
        continuous: '連続日数',
        activity: '活動状況',
        time: '時刻',
        amount: '電気使用量(kWh)'
      }
    },
    partnerInvoices: {
      name: '請求',
      fields: {
        month: '表示月',
        partner: '事業者',
        product: 'サービス名称',
        date: '請求月',
        price: '単価',
        count: '数量',
        amount: '金額(税抜)'
      },
      display: {
        date: '請求明細発行日　',
        partner: 'お客様情報　',
        company: '',
        companyNumber: '',
        companyAddress: '',
        items: '請求額',
        details: 'ご明細',
        sum: '合計(税抜) ',
        tax: '消費税(10%) ',
        sumWithTax: '合計(税込) ',
        count: '数量',
        price: '単価',
        amount: '金額',
        name: 'サービス内容',
        duration: 'サービス期間: '
      },
      unit: {
        sum: '円',
        tax: '円',
        sumWithTax: '円',
        count: '',
        price: '円',
        amount: '円'
      },
      company: '中部電力ミライズコネクト株式会社',
      companyAddress:
        '〒460-0008\n愛知県名古屋市中区栄4丁目5-3\nKDX名古屋栄ビル10階\n052-211-9971(代表)',
      companyNumber: '登録番号 T9180001145479'
    },
    partnerPreferences: {
      name: 'システム設定',
      fields: {
        email: '社内通知の送信先メールアドレス',
        emailSender: 'メールの送信者アドレス',
        emailNotificationSender: '社内通知メールの送信者アドレス',
        sms: 'SMS送信者ID (英数字およびハイフンで11文字以内、先頭は英字)',
        templates: {
          inactive: {
            sms: '【活動未検知】SMSテンプレート',
            notifySubject: '【活動未検知】社内通知メールテンプレート(件名)',
            notifyBody: '【活動未検知】社内通知メールテンプレート(本文)'
          },
          call: {
            notifySubject:
              '【本人への電話確認要請】社内通知メールテンプレート(件名)',
            notifyBody:
              '【本人への電話確認要請】社内通知メールテンプレート(本文)'
          },
          callDone: {
            notifySubject:
              '【本人への電話確認完了】社内通知メールテンプレート(件名)',
            notifyBody:
              '【本人への電話確認完了】社内通知メールテンプレート(本文)'
          },
          familyCall: {
            notifySubject:
              '【家族への電話確認要請】社内通知メールテンプレート(件名)',
            notifyBody:
              '【家族への電話確認要請】社内通知メールテンプレート(本文)'
          },
          familyCallDone: {
            notifySubject:
              '【家族への電話確認完了】社内通知メールテンプレート(件名)',
            notifyBody:
              '【家族への電話確認完了】社内通知メールテンプレート(本文)'
          },
          partner: {
            subject:
              '【活動未検知の事業者への連絡】事業者へのメールのテンプレート(件名)',
            body: '【活動未検知の事業者への連絡】事業者へのメールのテンプレート(本文)',
            notifySubject:
              '【活動未検知の事業者への連絡】社内通知メールテンプレート(件名)',
            notifyBody:
              '【活動未検知の事業者への連絡】社内通知メールテンプレート(本文)'
          },
          postReport: {
            notifySubject: '【安否確認完了】社内通知メールテンプレート(件名)',
            notifyBody: '【安否確認完了】社内通知メールテンプレート(本文)'
          },
          serviceStart: {
            sms: '【サービス開始】SMSテンプレート',
            notifySubject: '【サービス開始】社内通知メールテンプレート(件名)',
            notifyBody: '【サービス開始】社内通知メールテンプレート(本文)'
          },
          serviceQuit: {
            sms: '【サービス終了】SMSテンプレート',
            notifySubject: '【サービス終了】社内通知メールテンプレート(件名)',
            notifyBody: '【サービス終了】社内通知メールテンプレート(本文)'
          },
          noElectricityUsage: {
            notifySubject: '【電気使用量なし】社内通知メールテンプレート(件名)',
            notifyBody: '【電気使用量なし】社内通知メールテンプレート(本文)'
          }
        },
        postReportResponse: '安否確認の応答として表示するHTMLコンテンツ'
      }
    },
    partnerShortMessages: {
      name: 'ショートメッセージ',
      fields: {
        to: '送信先番号',
        toId: '送信先',
        body: '送信内容',
        status: '内容',
        dateTime: '送信日時',
        success: '送信結果'
      }
    },
    partnerEmails: {
      name: 'メール',
      fields: {
        to: '送信先アドレス',
        toId: '対象者',
        cc: 'Ccアドレス',
        bcc: 'BCcアドレス',
        subject: '件名',
        body: '本文',
        status: '内容',
        dateTime: '送信日時',
        success: '送信結果'
      }
    },
    partnerTests: {
      name: 'デモ/テスト',
      fields: {
        user: '利用者',
        date: '対象日',
        endDate: '対象日(まで)',
        start: '開始時間',
        duration: '時間',
        activity: '活動状況の種別',
        dateTime: '実行日時'
      },
      title: 'テストデータを生成'
    },
    orderA: {
      name: 'テラシテA申込フォーム',
      submit: {
        l1: '内容を確認し',
        l2: '送信する'
      }
    },
    orderR: {
      name: 'テラシテR申込フォーム',
      title: 'お申し込みフォーム',
      fields: {
        name: '氏名',
        nameKana: '氏名(カナ)',
        postalCode: '郵便番号(ハイフンなし)',
        address: '住所',
        place: '物件名',
        placeNumber: '部屋番号',
        sms: 'SMS送信先電話番号(ハイフンなし)',
        phone: '音声連絡先電話番号(ハイフンなし)',
        customerNumber: '電気契約のお客様番号(13桁数字)',
        email: 'メールアドレス',
        familyName: '緊急連絡先氏名',
        familyNameKana: '緊急連絡先氏名カナ',
        familyPhone: '緊急連絡先電話番号(ハイフンなし)',
        familyPostalCode: '緊急連絡先郵便番号',
        identification: '公的証明書番号',
        bankCode: '金融機関コード',
        branchCode: '支店コード',
        accountType: '預金区分',
        accountNumber: '口座番号',
        accountName: '口座名義カナ',
        accountNameKanji: '口座名義(漢字)',
        savings: '普通',
        current: '当座',
        entry: '入居予定日'
      },
      addressInput: '住所自動入力',
      submit: {
        l1: '登録'
      },
      userTitle: 'ご契約者',
      familyTitle: '緊急連絡先',
      bankAccount: {
        title: '口座振替登録',
        dialog: {
          content: '金融機関サイトへ移動します',
          ok: '確認'
        },
        submitButton: '登録'
      }
    },
    safetyAnswer: {
      title: '安否状況ご回答フォーム',
      header:
        'つきましては、下記の安否状況登録をお願いいたします。\nなお、被災状況は不動産管理会社に対してご共有いたします。',
      fields: {
        status: 'お怪我はありませんか？',
        houseStatus: 'お住まいに被害はございませんか？',
        messageTitle: 'その他何かございましたらご記入ください。',
        message: 'メッセージ'
      },
      submit: {
        l1: '回答'
      },
      reportTo: 'ご回答の通知先',
      statusString: {
        0: '無事',
        1: '軽傷',
        2: '重症'
      },
      houseStatusString: {
        0: 'なし',
        1: 'あり',
        2: '不明'
      }
    },
    safetyReport: {
      title: '安否状況ご連絡フォーム',
      header:
        'つきましては、nameさまの安否状況を確認いたしましたので、以下の通りご連絡させていただきます。\nなお、被災状況は不動産管理会社に対してご共有いたします。',
      reportFrom: '安否状況のご回答者'
    },
    safetyNotification: {
      title: '台風接近に伴う注意喚起',
      message:
        'ベランダなどに強風で飛ばされる恐れがある物は室内に移動をお願いいたします。'
    },
    safetyAnswerReport: {
      message: 'ご回答ありがとうございます。'
    },
    partnerReport: {
      title: '安否確認結果送信フォーム',
      fields: {
        name: '入居者氏名',
        place: '物件名',
        placeNumber: '部屋番号',
        status: '安否確認状況',
        report: '備考'
      },
      header:
        '平素は大変お世話になっております。\n中部電力ミライズコネクト 見守りサービス事務局でございます。\n\n弊社見守りサービスにより、現在入居者の宅内での安否が確認できておりません。\nつきましては、入居者への安否を実施いただき、安否確認状況に関するご回答をお願いいたします。',
      submit: {
        l1: '送信'
      },
      response: '回答ありがとうございます'
    },
    'partnerReport.c158f23e-a20f-404a-b8c4-c5beb0524983': {
      title: '安否確認結果送信フォーム',
      fields: {
        name: '入居者氏名',
        place: '物件名',
        placeNumber: '部屋番号',
        status: '安否確認状況',
        report: '備考'
      },
      header:
        '平素は大変お世話になっております。\n中部電力ミライズコネクト 見守りサービス事務局でございます。\n\n弊社見守りサービスにより、現在入居者の宅内での安否が確認できておりません。\nつきましては、入居者への安否を実施いただき、安否確認状況に関するご回答をお願いいたします。',
      submit: {
        l1: '送信'
      },
      response: '回答ありがとうございます'
    },
    codingAssesment: {
      title: 'コーディングスキル試験',
      fields: {
        name: '氏名'
      },
      header: '',
      submit: {
        l1: '送信'
      },
      start: '開始',
      loading: 'テストを開始します',
      input: 'ここにソースコードを入力してください',
      response: 'お疲れ様でした'
    },
    schedule: {
      title: 'Thank you for your reporting.',
      header: 'Please select dates if you have any outgoing schedules.',
      thanks: 'Thank you for your answer.',
      tahnksFooter:
        'You can modify your schedules from url in the short messages',
      submit: {
        l1: 'Register'
      },
      clear: 'Clear',
      cancle: 'None'
    },
    title: 'Terashite R',
    'title.c158f23e-a20f-404a-b8c4-c5beb0524983': 'テラシテR'
  },
  mine: {
    title: 'テラシテAサービス管理ページ',
    users: {
      edit: '登録情報の変更',
      credit: {
        l1: 'クレジットカード情報の',
        l2: '登録・変更'
      },
      criterions: '判定条件の変更',
      houseEdit: 'ハウスの登録情報の変更',
      registerTitle: '利用者登録',
      housees: 'ハウスの設定・変更',
      house: 'ハウス名称',
      houseShow: 'ハウスの電気使用量',
      addHouse: 'ハウスの追加',
      invoice: '請求表示'
    },
    partners: {
      edit: '登録情報の変更',
      title: '登録情報の変更',
      createSave: '登録',
      next: '次へ'
    },
    user: {
      houseName: 'ハウス名称',
      createSave: '登録'
    },
    activity: {
      active: '活動あり',
      inactive: '活動なし'
    },
    chart: {
      activity: '活動状況',
      active: '活動あり',
      electricityUsage: '電気使用量',
      electricityUsageBefore: '前日の電気使用量',
      inactive: '活動なし'
    },
    messageResult: {
      done: '完了',
      fail: '失敗',
      unable: '-'
    },
    criterions: {
      month: '月',
      startDate: '判定開始日',
      endDate: '判定終了日',
      start: '判定開始時刻',
      end: '判定終了時刻',
      continuousLimit: '判定継続日数',
      title: '判定条件の変更',
      criterion: '判定条件'
    },
    auth: {
      cannotLogin: 'ログインできません',
      confirm: 'パスワード(確認)',
      forgotPassword: 'パスワードを忘れた方はこちら',
      login: 'ログイン',
      newPassword: '新しいパスワード',
      password: 'パスワード',
      send: '送信',
      set: '設定',
      username: 'メールアドレス',
      verificationCode: '確認コード'
    },
    pagination: {
      next: '次へ',
      perPage: 'ページごとの項目数',
      previous: '前へ'
    },
    test: {
      active: 'アクティブ',
      createElectricityUsageData: '電気使用量データ生成',
      execute: '実行',
      inactive: '非アクティブ',
      notificationReportCheck: '安否確認回答チェック',
      endDate: '2日以上の場合に設定',
      save: '作成'
    },
    labels: {
      call: '本人への電話連絡',
      callStatus: {
        yet: '未実施',
        noAnswer: '繋がらず',
        confirmed: '確認完了',
        other: 'その他'
      },
      confirmed: '確認済み',
      criterionInput: {
        all: '全て同じ',
        done: '入力完了',
        open: '判定条件の入力',
        title: '判定条件の入力'
      },
      done: '連絡済み',
      familyCall: '緊急連絡先への電話連絡',
      goToBed: '就寝',
      inactive: '活動未検知',
      inputCallResult: '電話連絡結果',
      month: '月',
      monthLabels: {
        0: '1月',
        1: '2月',
        2: '3月',
        3: '4月',
        4: '5月',
        5: '6月',
        6: '7月',
        7: '8月',
        8: '9月',
        9: '10月',
        10: '11月',
        11: '12月'
      },
      name: '法人名称',
      partner: '事業者',
      register: '登録',
      scrollTop: '先頭に戻る',
      scrollBottom: '最後に移動',
      spin: '供給地点特定番号',
      templates: {
        inactive: '活動未検知',
        call: '本人への電話連絡',
        callDone: '本人への電話連絡完了',
        familyCall: '家族への電話連絡',
        familyCallDone: '家族への電話連絡完了',
        forget: 'URLの通知',
        postReport: '安否確認完了',
        partner: '事業者への連絡',
        serviceStart: '利用開始の連絡',
        serviceQuit: '利用終了の連絡',
        noElectricityUsage: '電気使用量がない場合の通知'
      },
      wakeUp: '起床',
      waiting: '連絡待ち',
      userName: '氏名',
      byUserName: '氏名で検索',
      deleteButton: '解約',
      deleteTitle: '解約の確認',
      deleteConfirm: '解約処理を実行しますか'
    },
    registerCompleteFormTitle: 'クレジットカード登録完了',
    credit: {
      finish: '登録完了しました。',
      next1: '判定条件の設定等は、',
      next2: 'こちら',
      next3: 'からお願いします。',
      dialogs: {
        sendSmsRequest:
          'クレジットカード編集用のSMSを送信します。\n編集期限は10分間となります。',
        sendSmsResult:
          'SMSを送信しました。\n編集失敗時は再度SMSの編集用URLからやり直しをお願いします。\n編集期限切れとなった場合は、再度管理ページから編集の操作をやり直してください。',
        registrationFail:
          'クレジットカード登録に失敗しました。\n登録手続きを完了させてください。',
        register:
          '引き続きクレジットカード登録をお願いします。\nクレジットカード入力画面へ遷移します。',
        registerSub: 'クレジットカード入力画面へ遷移します。',
        close: '閉じる'
      }
    }
  },
  'No current user': 'ログインしていません',
  'users deleted': '削除処理を実行しました',
  'too long': '10日以内で指定してください',
  'must future': '開始日以降を指定してください',
  'wrong postal code':
    '郵便番号の形式が間違っています。"半角数字3桁-半角数字4桁"の形式でお願いします。',
  'no name': 'お名前が入力されていません',
  'no phone': '携帯電話番号が入力されていないか形式が正しくありません',
  'no agreement': '利用規約への同意が必要です',
  'order completed': 'お申込みを受付ました',
  'spin exists': 'お客様番号が重複しています',
  'not existing code': '紹介コードが見つかりません',
  'illegal postal code': '郵便番号が正しくありません',
  'too small': '文字数が不足しています',
  'too large': '文字数が多すぎます',
  Required: '入力されていません',
  required: '入力されていません',
  'Expected string, received null': '入力されていません',
  'invalid type': '形式が不正です',
  'too short customer number': 'お客様番号は13桁です'
}
